/** Escopo operacional vs histórico de justificativas (data da falta). */

export type EscopoJustificativa = 'ATIVAS' | 'HISTORICO' | 'TODAS';

/** Status de UI: PENDENTE só vale no prazo; depois vira VENCIDA se não processada. */
export type StatusExibicaoJustificativa =
  | 'PENDENTE'
  | 'VENCIDA'
  | 'ACEITA'
  | 'RECUSADA';

export function toYmdLocal(dateStr: string): string {
  if (!dateStr) return '';
  try {
    const dtStr = dateStr.includes('T') ? dateStr : `${dateStr}T12:00:00`;
    const d = new Date(dtStr);
    if (isNaN(d.getTime())) return dateStr.slice(0, 10);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  } catch {
    return dateStr.slice(0, 10);
  }
}

/**
 * Ativa (fila): só enquanto a data da falta ainda não passou (inclui o dia da falta).
 * Depois da data → histórico (some da fila), mesmo se ainda PENDENTE.
 */
export function isJustificativaAtiva(
  j: { dataFalta: string; status: string },
  hojeStr: string,
): boolean {
  const ymd = toYmdLocal(j.dataFalta);
  return !!ymd && ymd >= hojeStr;
}

/**
 * Exibição no cliente:
 * - ACEITA / RECUSADA → como estão
 * - PENDENTE no prazo → Em Análise
 * - PENDENTE fora do prazo (não processada) → Vencida (ativas e histórico)
 */
export function resolverStatusExibicao(
  j: { dataFalta: string; status: string },
  hojeStr: string,
): StatusExibicaoJustificativa {
  if (j.status === 'ACEITA' || j.status === 'RECUSADA') {
    return j.status;
  }
  // Qualquer não processada (PENDENTE ou legado) após a data da falta
  if (!isJustificativaAtiva(j, hojeStr)) return 'VENCIDA';
  return 'PENDENTE';
}

export function filterJustificativasPorEscopo<
  T extends { dataFalta: string; status: string },
>(lista: T[], escopo: EscopoJustificativa, hojeStr: string): T[] {
  if (escopo === 'TODAS') return lista;
  if (escopo === 'ATIVAS') {
    // Só ativas no prazo — e tipicamente Em Análise / decididas do dia
    return lista.filter((j) => isJustificativaAtiva(j, hojeStr));
  }
  return lista.filter((j) => !isJustificativaAtiva(j, hojeStr));
}
